import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class TaskCategoryModel extends Model {
  static reducer(action, TaskCategoryModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.TaskCategory.schema:
        action.payload.forEach((payload) => {
          const dbData = TaskCategoryModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          TaskCategoryModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
TaskCategoryModel.modelName = "TaskCategoryModel";

TaskCategoryModel.fields = {
  id: attr(),
};

export default TaskCategoryModel;